<template>
  <div v-if="cols.length > 0" class="mb-3">
    <el-table :data="cols" style="width: 100%">
      <el-table-column
        sortable
        prop="marketingValue"
        :label="label"
        width="160"
      ></el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="caAcquisition"
        label="C.A Acqui."
        width="180"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content: `Montant total des commandes 'acquisition' des clients ayant rempli un formulaire pendant la période`,
              placement: 'top',
            }"
          ></i>
          C.A Acqui.
        </template>
        <template slot-scope="scope">
          {{ scope.row.caAcquisition.toFixed(2) }} €
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="caAcquisitionAverage"
        label="Panier moy. Acqui."
        width="200"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content: `Montant moyen des commandes 'acquisition' des clients ayant rempli un formulaire pendant la période (C.A acquisition / nb clients acquisition)`,
              placement: 'top',
            }"
          ></i>
          Panier moy. Acqui.
        </template>
        <template slot-scope="scope">
          {{ scope.row.caAcquisitionAverage.toFixed(2) }} €
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="caFidelisation"
        label="C.A Fidel."
        width="180"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content: `Montant total des commandes 'fidélisation' des clients ayant rempli un formulaire pendant la période`,
              placement: 'top',
            }"
          ></i>
          C.A Fidel.
        </template>
        <template slot-scope="scope">
          {{ scope.row.caFidelisation.toFixed(2) }} €
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="caFidelisationAverage"
        label="Panier moy. Fidel."
        width="200"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content: `Montant moyen des commandes 'fidélisation' des clients ayant rempli un formulaire pendant la période (C.A fidelisation / nb clients fidelisation)`,
              placement: 'top',
            }"
          ></i>
          Panier moy. Fidel.
        </template>
        <template slot-scope="scope">
          {{ scope.row.caFidelisationAverage.toFixed(2) }} €
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="ca"
        label="C.A Total"
        width="150"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content: `C.A acquisition + C.A fidélisation (i.e hors séances découvertes)`,
              placement: 'top',
            }"
          ></i>
          C.A Total
        </template>
        <template slot-scope="scope">
          {{ scope.row.ca.toFixed(2) }} €
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="caAverage"
        label="C.A Moyen"
        width="150"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content: `Montant moyen des commandes des clients ayant rempli un formulaire pendant la période (C.A total / nb formulaires)`,
              placement: 'top',
            }"
          ></i>
          C.A Moyen
        </template>
        <template slot-scope="scope">
          {{ scope.row.caAverage.toFixed(2) }} €
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="amount"
        label="Dépenses"
        width="150"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content: 'Dépenses publicitaires pendant la période',
              placement: 'top',
            }"
          ></i>
          Dépenses
        </template>
        <template slot-scope="scope">
          {{ scope.row.amount.toFixed(2) }} €
        </template>
      </el-table-column>

      <el-table-column align="center" width="180" sortable label="ROAS">
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content:
                'Return On Ad Spend (ROAS) = C.A total / dépenses publicitaires',
              placement: 'top',
            }"
          ></i>
          ROAS
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.ca !== 0 && scope.row.amount !== 0">
            {{ (scope.row.ca / scope.row.amount).toFixed(2) }} € ({{
              ((scope.row.ca / scope.row.amount) * 100).toFixed(2)
            }}%)

            <i
              class="fa fa-info-circle ml-05"
              v-tooltip="{
                content: `Pour 1€ dépensé = ${(
                  scope.row.ca / scope.row.amount
                ).toFixed(2)}€ de CA (soit ${(
                  (scope.row.ca / scope.row.amount) *
                  100
                ).toFixed(2)}% de retour sur investissement)`,
              }"
            ></i>
          </span>
          <span v-else-if="scope.row.amount === 0">Aucune dépense</span>
          <span v-else-if="scope.row.ca === 0">(0%)</span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="nbClientsProspects"
        label="Formulaires"
        width="150"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content:
                'Nombre de formulaires remplis (prospects) pendant la période',
              placement: 'top',
            }"
          ></i>
          Formulaires
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="nbProspectsConvert"
        label="Prospects Convertis"
        width="220"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content:
                'Prospects ayant payé une séance découverte pendant la période',
              placement: 'top',
            }"
          ></i>
          Prospects Convertis
        </template>
        <template slot-scope="scope">
          {{ scope.row.nbProspectsConvert }}
          <span class="small">
            ({{
              (
                (scope.row.nbProspectsConvert / scope.row.nbClientsProspects) *
                100
              ).toFixed(2)
            }}%)
          </span>
        </template></el-table-column
      >

      <el-table-column
        align="center"
        sortable
        prop="nbClients"
        label="Clients"
        width="200"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content:
                'Prospects ayant acheté un pack pendant la période et ayant fait une séance découverte auparavant',
              placement: 'top',
            }"
          ></i>
          Clients
        </template>
        <template slot-scope="scope">
          {{ scope.row.nbClients }}
          <span class="small">
            ({{
              (
                (scope.row.nbClients / scope.row.nbClientsProspects) *
                100
              ).toFixed(2)
            }}%)
          </span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="nbProspectsLosts"
        label="Perdus"
        width="200"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content:
                'Prospects perdus pendant la période (ayant fait une séance découverte auparavant)',
              placement: 'top',
            }"
          ></i>
          Perdus
        </template>
        <template slot-scope="scope">
          {{ scope.row.nbProspectsLosts }}
          <span class="small">
            ({{
              (
                (scope.row.nbProspectsLosts / scope.row.nbClientsProspects) *
                100
              ).toFixed(2)
            }}%)
          </span>
          <span
            v-if="scope.row.nbProspectsLosts > 0"
            style="display: inline-block; margin-left: 2px"
            class="fa fa-info-circle"
            v-tooltip="{
              content: scope.row.lostReasons,
              placement: 'bottom',
            }"
          ></span>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        sortable
        prop="conversionRate"
        label="Taux de conversion"
        width="200"
      >
        <template slot="header">
          <i
            class="fa fa-info-circle"
            v-tooltip="{
              content:
                'Taux de conversion des prospects (formulaires) en clients',
              placement: 'top',
            }"
          ></i>
          Taux de conversion
        </template>
        <template slot-scope="scope">
          {{ scope.row.conversionRate.toFixed(2) }}%
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    cols: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
};
</script>
